// @internal
import './window-operations';

// @internal
import {Component, ComponentRegistry} from './component-registry-service';

export default class FrameComponent extends Component
{
	private readonly scriptElement: HTMLScriptElement;
	private readonly iframeElement: HTMLIFrameElement;
	private observer: MutationObserver;

	constructor(scriptElement: HTMLScriptElement)
	{
		super();

		if (!(scriptElement instanceof HTMLScriptElement))
		{
			throw new Error('containerElement is not an HTMLScriptElement');
		}

		this.scriptElement = scriptElement as HTMLScriptElement;
		this.iframeElement = document.createElement('IFRAME') as HTMLIFrameElement;
		this.iframeElement.classList.add('for-frame');
		this.iframeElement.style.width = '100%';

		this.scriptElement.parentElement?.insertBefore(this.iframeElement, this.scriptElement);

		let html = '<!DOCTYPE html><html><head>' + document.head.innerHTML + '</head><body class="for-frame-body">' + this.scriptElement.text;

		let scriptElements = document.body.querySelectorAll('script') as NodeListOf<HTMLScriptElement>;

		for (let i = 0; i < scriptElements.length; i++)
		{
			if (!scriptElements[i].type || scriptElements[i].type == 'text/javascript')
			{
				html += scriptElements[i].outerHTML;
			}
		}

		html += '</body></html>';

		this.iframeElement.scrolling = 'no';
		this.iframeElement.addEventListener('load', this.onLoad.bind(this));
		this.iframeElement.srcdoc = html;

		window.addEventListener('resize', this.resizeFrame.bind(this));

		window.setImmediate(this.resizeFrame.bind(this));

		setTimeout(this.resizeFrame.bind(this), 1000);
	}

	destroy()
	{
		this.iframeElement.remove();
	}

	private onLoad()
	{
		try
		{
			if (this.observer)
			{
				this.observer.disconnect();
			}
		}
		catch (_ex){}

		// Prevent the body from filling the entire iframe; only use the space needed to render the content.
		// We need this to determine an accurate height for the body when calling resizeFrame.
		const wnd = this.iframeElement.contentWindow;
		
		if (wnd)
		{
			wnd.document.documentElement.style.height = 'auto';
			wnd.document.body.style.height = 'auto';
		}

		// When anything on the page changes, recalculate the iframe height.
		this.observer = new MutationObserver(this.resizeFrame.bind(this));
		this.observer.observe(this.iframeElement.contentWindow?.document.documentElement as HTMLElement, { childList: true, subtree: true, attributes: true });

		// Initial iframe height calculation.
		this.resizeFrame();
	}

	private resizeFrame()
	{
		if (this.iframeElement.contentWindow && this.iframeElement.contentWindow.document && this.iframeElement.contentWindow.document.body)
		{
			this.iframeElement.style.height = (this.iframeElement.contentWindow.document.body.getBoundingClientRect().height) + 'px';
		}
	}
}

ComponentRegistry.register(FrameComponent, 'script', 'for-frame');
